// extracted by mini-css-extract-plugin
export default {"root":"BeneficiariesList_root__4QHbN","root_nothing":"BeneficiariesList_root_nothing__tFCvP","window":"BeneficiariesList_window__6W7lx"};